import { AlertTriangle, RotateCcw } from 'lucide-react';
import { Component, type ErrorInfo, type ReactNode } from 'react';

export class AppErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('FieldWise Sign interface error', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="fatal-error">
        <div>
          <AlertTriangle size={30} />
          <span className="eyebrow">Workspace recovery</span>
          <h1>The document workspace needs to restart.</h1>
          <p>Your source PDF was not changed. Reload the workspace and open it again.</p>
          <button type="button" onClick={() => window.location.reload()}><RotateCcw size={16} /> Reload workspace</button>
          <small>{this.state.error.message}</small>
        </div>
      </main>
    );
  }
}
